export default __webpack_public_path__ + "static/2159-e490865b68dd1d5a6612a960ae637f0c.gif";